import React from "react";
import styled from "styled-components";
import {
  mediaQuery,
  pageContentMaxWidth,
  pageContentPadding
} from "../../theme/constants";

interface ContentContainerProps {
  backgroundColor?: string;
  className?: string;
}

export const ContentContainer = (
  props: React.PropsWithChildren<ContentContainerProps>
) => {
  return (
    <Container
      color={props.backgroundColor ?? "none"}
      className={props.className}
    >
      {props.children}
    </Container>
  );
};

const Container = styled.div<{
  color: string;
}>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: ${(props) => props.color};
  position: relative;
  height: 100%;
  margin: 0 calc((100% - ${pageContentMaxWidth}px) / 2);
  ${mediaQuery.large} {
    margin: 0 ${pageContentPadding.large}px;
  }
  ${mediaQuery.medium} {
    margin: 0 ${pageContentPadding.medium}px;
  }
  ${mediaQuery.small} {
    margin: 0 ${pageContentPadding.small}px;
  }
`;
